export default "__VITE_ASSET__73d66e97__"